<template>
    <v-dialog v-model="_value" persistent width="300">
        <v-card color="blue-grey darken-4">
            <v-card-text class="subheading white--text"> {{message}}
                <v-layout row justify-center>
                <v-progress-linear :indeterminate="true" :size="70" :width="5" color="white"
                ></v-progress-linear>
                </v-layout>
            </v-card-text>
        </v-card>
    </v-dialog>
</template>

<script>
export default {
    model: {
        prop: 'show',
        event: 'change'
    },
    props: {
        message: String,
        show: {
            type: Boolean,
            default: false
        },
    },
    computed: {
        _value: {
            get: function () {
                return this.show
            },
            set: function (newVal) {
                this.$emit('change', newVal)
            }
        }
    }
}
</script>